import { Col, Row } from 'antd';
import helpers from '../../../../../common/helpers/common';
import { InputNumberComponent } from './InputNumber';

type props = {
    isEditing: boolean;
    dueDate?: number;
};

export const ExpirationDateComponent = ({ isEditing, dueDate }: props) => {
    return (
        <>
            <section className="ord007-header-style" style={{ marginTop: 8 }}>
                有効期限　お知らせ通知
            </section>
            <section style={{ width: '100%', display: 'flex' }}>
                <div className="center-item ord007-cell-container ord007-border-left half-width">
                    通知日
                </div>
                <div className="center-item ord007-cell-container half-width">
                    {isEditing ? (
                        <>
                            <InputNumberComponent name="dueDate" max={99} isRequired={true} />
                            <div style={{ color: '#666666', marginLeft: 8 }}>日前</div>
                        </>
                    ) : (
                        `${dueDate ? dueDate + '日前' : ''}`
                    )}
                </div>
            </section>
        </>
    );
};
